const IMG_VERSION = "2";

export const bust = (src) => {
  if (!src) return src;
  return src.startsWith("/images/") ? `${src}?v=${IMG_VERSION}` : src;
};
